import React, { useState, useEffect, useContext } from "react"
import axios from 'axios'
import DataTable from 'react-data-table-component'
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"

import { GlobalContext, HOST } from "./context/GlobalContext"
import { NumeroALetras } from "./PriceToText"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Modal from 'react-bootstrap/Modal'

import './App.css';
import { ArrowReturnLeft, CartCheckFill, CashCoin, CashStack, Clipboard2CheckFill } from "react-bootstrap-icons";

import laJornada from './img/logo.png'

const DEVOLUCION_UPDATE_API = HOST + '/api/inv/devoluciones/update/'
const DEVOLUCION_APROVACION_API = HOST + '/api/inv/devoluciones/approve/'
const DEVOLUCION_APROVACION_EXITOSA_API = HOST + '/api/inv/devoluciones/approved/'
const DEVOLUCION_RECHAZAR_API = HOST + '/api/inv/devoluciones/decline/'

const LIQUIDACIONES_API = HOST + '/api/inv/liquidaciones/'
const LIQUIDACION_UPDATE_API = HOST + '/api/inv/liquidacion/partial/update'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT_COMPLETE = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })
const DATE_FORMAT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'short', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })
const DATE_FORMAT_SHORT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'long', day: '2-digit', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })


function Devoluciones() {
  const { setGlobalLoading, formDataToJson, setMailBody, setMailTitle, setShowMesage, getLibros, setCallback, getVencimientos, getVencidos, getNombreEstado, getNombreLibro, showMesage, callback, proveedoresList, editorasList, vencimientosList, vencidosList, token, rol } = useContext(GlobalContext);

  const [ removeId, setRemoveId ] = useState(null)

  const [ showDesc, setShowDesc ] = useState(false)
  const [ show, setShow ] = useState(false)
  const [ showAlmacen, setShowAlmacen ] = useState(false)
  const [ showProv, setShowProv ] = useState(false)
  const [ action, setAction ] = useState('Mercancia a Devolver / Liquidar')
  const [ cloneVencimientosList, setCloneVencimientosList ] = useState([])

  const [key, setKey] = useState('proximos');
  const [inputFields, setInputFields] = useState([])
  const [remisionSelected, setRemisionSelected] = useState(null)
  const [showPrint, setShowPrint] = useState(false)
  const [partidasRes, setPartidasRes] = useState([])
  const [descuentoGlobal, setDescuentoGlobal ] = useState([])
  const [descuentoGlobalLiq, setDescuentoGlobalLiq ] = useState([])
  const [operationType, setOperationType] = useState('dev')
  const [disableEdit, setDisableEdit] = useState(false)
  
  const [showParcial, setShowParcial] = useState(false)
  const [inputLiquidaciones, setInputLiquidaciones] = useState([])
  const [liquidacionesList, setLiquidacionesList] = useState([])
  const [liquidacionesCantidad, setLiquidacionesCantidad] = useState(0)
  const [liquidacionesNeto, setLiquidacionesNeto] = useState(0)
  const [liquidacionesSubtotal, setLiquidacionesSubtotal] = useState(0)
  const [idLiquidacionParcial, setIdLiquidacionParcial] = useState(0)

  useEffect(() => {
    setInputFields([])
    setGlobalLoading( true )
    getLibros()
  }, []);

  useEffect(() => {
    getVencimientos(key)
  }, [ key ]);

  useEffect(() => {
    let clone = []

    vencimientosList.map( (item, i) => {
      let cantidadRealDevolver = 0
      let cantidadRealLiquidar = 0
      let cantidadDevolver = 0
      let cantidadLiquidar = 0
      let montoDevolver = 0
      let montoLiquidar = 0

      item.entradas.map( e => {
        if( e.devolucion ) {
          cantidadDevolver += e.devolucion.cantidadDevuelta
          cantidadLiquidar += e.devolucion.cantidadLiquidar

          montoDevolver += e.devolucion.netoDevolucion
          montoLiquidar += e.devolucion.netoLiquidacion

          cantidadRealDevolver += e.devolucion.cantidadDevuelta * e.precio
          cantidadRealLiquidar += e.devolucion.cantidadLiquidar * e.precio
        } else {
          cantidadDevolver += e.cantidadRestante
          cantidadLiquidar += (e.cantidad - e.cantidadRestante)

          montoDevolver += (e.cantidadRestante * e.ordenDetalle.costo)
          montoLiquidar += ((e.cantidad - e.cantidadRestante) * e.ordenDetalle.costo)
        }
      })

      clone.push(item)
      clone[i].cantidadRealDevolver = cantidadRealDevolver
      clone[i].cantidadRealLiquidar = cantidadRealLiquidar
      clone[i].cantidadDevolver = cantidadDevolver
      clone[i].cantidadLiquidar = cantidadLiquidar
      clone[i].montoDevolver = montoDevolver 
      clone[i].montoLiquidar = montoLiquidar
    })

    setCloneVencimientosList(clone)
  }, [ vencimientosList ]);

  const settingInputs = ( remision, parcial, approve ) => {
    let temp = []
    let descGlobal = 0
    let descGlobalLiq = 0
    let currentRemision = JSON.parse(JSON.stringify(remision))
    console.log("Remision seleccionada", currentRemision)
    setRemisionSelected(currentRemision)

    remision.entradas.map( (item, i) => {
      if(item.devolucion) {
        temp.push(item.devolucion)

        descGlobal += ( (parseFloat(item.precio) * item.devolucion.cantidadDevuelta) - (parseFloat(item.ordenDetalle.costo) * item.devolucion.cantidadDevuelta) )
        descGlobalLiq += ( (parseFloat(item.precio) * item.devolucion.cantidadLiquidar) - (parseFloat(item.ordenDetalle.costo) * item.devolucion.cantidadLiquidar) )
      } else {
        temp.push({ 
          idDevolucion: null,
          idLibro: item.idLibro,
          idAlmacen: 0,
          fecha: null,
          descripcion: 'Sin Comentario',
          cantidadEntrada: item.cantidad,
          cantidadDevuelta: item.cantidadRestante,
          cantidadLiquidar: item.cantidad - item.cantidadRestante,
          netoDevolucion: (item.cantidadRestante * item.ordenDetalle.costo).toFixed(2),
          netoLiquidacion: ((item.cantidad - item.cantidadRestante) * item.ordenDetalle.costo).toFixed(2),
          idEntrada: item.idEntrada,
          estatus: true,
          usuarioRegistra: null,
          fechaRegistra: null
        })
      }

      temp[i].title = item.title
      temp[i].proveedor = item.proveedor
      temp[i].precio = item.precio
      temp[i].cantidad = item.cantidad
      temp[i].cantidadRestante = item.cantidadRestante
      temp[i].ordenDetalle = item.ordenDetalle
      temp[i].cantidadDevueltaOrg = temp[i].cantidadDevuelta
      temp[i].cantidadLiquidarOrg = temp[i].cantidadLiquidar
      
    })

    if(currentRemision.estatusDevolucion === 'abierta' || currentRemision.estatusDevolucion === 'rechazada')
      setDisableEdit(false)
    else setDisableEdit(true)

    setDescuentoGlobal(descGlobal)
    setDescuentoGlobalLiq(descGlobalLiq)
    setInputFields(temp)

    let clone = []      
    clone.push(...temp)
    
    /*for( let j = 0; j < 15; j++ ){
      clone.push(... partidasList)
    }*/

    if(parcial)
      getLiquidaciones(currentRemision.idRemision, temp, approve)
    else {
      prittingItemsList(clone)
      setShow(true)
    }

  }

  const getLiquidaciones = (id, remisionList, approve) => {
    axios({
      method: 'get',
      url: LIQUIDACIONES_API + '/' + id,
      headers: { 'Authentication': token }
    })
    .then(result => {
      //console.log("remision partidas", result.data)
      setLiquidacionesList(result.data)
      handleLiquidacion( result.data, remisionList, false, approve ? id : null )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const onChangeLiquidacion = ( val ) => {
    let liquidacion = liquidacionesList.find(element => parseInt(element.idLiquidacionParcial) === parseInt(val))
            
    setGlobalLoading( true )
    if(liquidacion) {
      let list = []
      list.push(liquidacion)
      
      handleLiquidacion( list, inputFields, true )
    } else 
      handleLiquidacion( liquidacionesList, inputFields, false )

    setIdLiquidacionParcial(val)
  }

  const handleLiquidacion = ( dataList, remisionList, history, idRem ) => {
    let data = dataList
    let cantidad = 0
    let total = 0
    let temp = []
    temp = JSON.parse(JSON.stringify(remisionList));

    if( data.length > 0 ){
      data.map( item => {
        item.liquidacionDetalle.map( ( input, i ) => {
          let foundEl = temp.find(element => { 
            if(parseInt(element.idLibro) === parseInt(input.idLibro)){ 
              return element 
            }

            return null
          })
          
          if(foundEl) {
            if(history) {
              foundEl.cantidadLiquidar = input.cantidadLiquidar
              foundEl.netoLiquidacion = input.netoLiquidacion
            } else {
              foundEl.cantidadLiquidar = foundEl.cantidadLiquidar - input.cantidadLiquidar
              foundEl.netoLiquidacion = foundEl.netoLiquidacion - input.netoLiquidacion
            }
          }

        })
      })
    }
    
    let descGlobalLiq = 0
    let subtotal = 0

    temp.map( input => {
      cantidad += input.cantidadLiquidar
      total += input.netoLiquidacion

      subtotal += (parseFloat(input.precio) * input.cantidadLiquidar)
      descGlobalLiq += ( (parseFloat(input.precio) * input.cantidadLiquidar) - (parseFloat(input.ordenDetalle.costo) * input.cantidadLiquidar) )
    })

    let clone = []      
    clone.push(...temp)
    prittingItemsList(clone)

    setInputLiquidaciones(temp)
    setLiquidacionesCantidad(cantidad)
    setDescuentoGlobalLiq(descGlobalLiq)
    setLiquidacionesNeto(total)
    setLiquidacionesSubtotal(subtotal)

    if( idRem ) {
      if(cantidad > 0) {
        setShowMesage(true)
        setMailTitle('Advertencia')
        setMailBody('Aun hay una liquidación parcial pendiente. Favor de Generar dicha liquidación antes de solicitar la aprobación de la devolución / liquidación Global.')
      } else {
        setGlobalLoading( true )
        approveStatus( idRem )
      }
    } else 
      setShowParcial(true)
    
    setGlobalLoading( false )
  }

  const prittingItemsList = ( clone ) => {
    console.log("large list", clone)

    let numberOfList = 0
    let mainList = clone.splice( 0, 20 )
    let resultList = []
    
    if( clone.length > 20 ) {
      let rest = clone.length

      console.log("operations", rest, Math.ceil( rest / 30 ))
      numberOfList = Math.ceil( rest / 30 )
    }

    resultList[0] = mainList 

    for ( let i = 0; i < numberOfList; i++ ) {      
      resultList[ i + 1 ] = clone.splice( 0, 30 )
    }

    setPartidasRes( resultList )
  }

  const handleFormChange = (index, item, event) => {
    let data = [...inputFields];
    let value = event.target.value;

    if( event.target.name === 'cantidadDevuelta') {
      
      let devueltaOrg = data[index]['cantidadDevueltaOrg']
      let liquidarOrg = data[index]['cantidadLiquidarOrg']

      data[index]['cantidadDevuelta'] = parseFloat(value)
      data[index]['cantidadLiquidar'] = parseFloat(liquidarOrg) + ( parseFloat(devueltaOrg) - parseFloat(value) )

      data[index]['netoDevolucion'] = data[index]['cantidadDevuelta'] * data[index]['ordenDetalle']['costo']
      data[index]['netoLiquidacion'] = data[index]['cantidadLiquidar'] * data[index]['ordenDetalle']['costo']

      recalcTotals(data)
    }

    data[index][event.target.name] = value

    setInputFields(data);
  }

  const recalcTotals = (inputData) => {
    let remisionClone = remisionSelected
    let devuelta = 0
    let liquidar = 0
    let netoDevuelta = 0
    let netoLiquidar = 0

    inputData.map( item => {
      devuelta += item.cantidadDevuelta
      liquidar += item.cantidadLiquidar
      netoDevuelta += item.netoDevolucion
      netoLiquidar += item.netoLiquidacion
    })

    remisionClone.cantidadDevolver = devuelta
    remisionClone.cantidadLiquidar = liquidar
    remisionClone.montoDevolver = netoDevuelta
    remisionClone.montoLiquidar = netoLiquidar
    
    setRemisionSelected(remisionClone)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    let clone = JSON.parse(JSON.stringify(inputFields))

    clone.map( item => {
      delete item.title
      delete item.proveedor
      delete item.precio
      delete item.cantidad
      delete item.cantidadRestante
      delete item.ordenDetalle
      delete item.cantidadDevueltaOrg
      delete item.cantidadLiquidarOrg
    })

    console.log('json to update devolucion', clone)

    axios.post(DEVOLUCION_UPDATE_API, clone, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      setShow(false)
      setGlobalLoading( false )
      getVencimientos(key)
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const updateLiquidacion = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    let json = {}
    let clone = JSON.parse(JSON.stringify(inputLiquidaciones))

    clone.map( item => {
      delete item.title
      delete item.proveedor
      delete item.precio
      delete item.cantidad
      delete item.cantidadRestante
      delete item.ordenDetalle
      delete item.cantidadDevueltaOrg
      delete item.cantidadLiquidarOrg
    })

    json = { idRemision: remisionSelected.idRemision, devoluciones: clone }
    console.log('json to update devolucion', json)

    axios.post(LIQUIDACION_UPDATE_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      setShowParcial(false)
      setGlobalLoading( false )
      getVencimientos(key)
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const approveStatus = (id) => {
    setGlobalLoading( true )

    axios.post(DEVOLUCION_APROVACION_API + id, {}, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result approve", result.data)
      setShowMesage(true)

      if( result.data === 'NO_AUTH'){ 
        setMailTitle('Error')
        setMailBody(`No se encontro una llave valida para este servicio.`)
      } else {
        setMailTitle('Enviado')
        setMailBody(`La devolución ah sido enviada para aprobación.`)
      }

      getVencimientos(key)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const approvedStatus = (id) => {
    setGlobalLoading( true )

    axios.post(DEVOLUCION_APROVACION_EXITOSA_API + id, {}, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result approve", result.data)
      setShowMesage(true)

      if( result.data === 'NO_AUTH'){ 
        setMailTitle('Error')
        setMailBody(`No se encontro una llave valida para este servicio.`)
      } else {
        setMailTitle('Aprobada')
        setMailBody(`¡La devolución ah sido aprobada!`)
      }

      setShow(false)
      getVencimientos(key)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const declineStatus = (id) => {
    setGlobalLoading( true )

    axios.post(DEVOLUCION_RECHAZAR_API + id, {}, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result approve", result.data)
      setShowMesage(true)

      if( result.data === 'NO_AUTH'){ 
        setMailTitle('Error')
        setMailBody(`No se encontro una llave valida para este servicio.`)
      } else {
        setMailTitle('Rechazada')
        setMailBody(`La devolución ah sido Rechazada.`)
      }

      setShow(false)
      getVencimientos(key)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const viewPrint = (operation) => {
    setOperationType(operation)
    setShowPrint(true)
  }

  const printPDF = () => {
    setGlobalLoading( true )
    let pages = partidasRes.length
    let slide = 0

    const infoPageElement = document.getElementById("App");
    const pdf = new jsPDF('p', 'mm', 'a4');

    function htmlCanvas() {
      slide++

      if( slide >= pages ) {
        pdf.save( operationType === 'dev' ? `devolucion_${remisionSelected.idRemision}.pdf` : `liquidacion_${remisionSelected.idRemision}.pdf`);
        setGlobalLoading( false )

        return
      }

      pdf.addPage();
      const elem = document.getElementById("App_" + slide);
      console.log("element", slide, elem)

      html2canvas(elem, {
        scale:3,
        useCORS: true,
        allowTaint: false
      }).then(canvas => {
        pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288, '', 'FAST');
        console.log("image added")
        htmlCanvas()
      })
    }

    html2canvas(infoPageElement, {
      onclone: document => {},
      scale:3,
      useCORS: true,
      allowTaint: false
    }).then(canvas => {

      pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288, '', 'FAST');
      htmlCanvas()
    });

  };

  const getTableDevolucion = (list) => {
    return (
      <Table responsive>
        <thead>
          <tr>
            <th>Solicitados</th>
            <th> { operationType === 'dev' ? 'Devolver' : 'Liquidar' }</th>
            <th>Unidad de Medida</th>
            <th>Código de barras</th>
            <th>Descripción</th>
            {/*<th>Costo</th>*/}
            <th>Precio Unitario</th>
            <th>Descuento</th>
            <th>Costo</th>
            <th>Importe</th>
          </tr>
        </thead>
        <tbody>
          { list.map((item, index) => {
            let libro = getNombreLibro( item.idLibro )
            console.log("item", item)
            return <tr key={ item.idPartida + "_" + index }>
              <td> 
                { item.cantidad }
              </td>
              <td> 
                { operationType === 'dev' ? item.cantidadDevuelta : item.cantidadLiquidar }
              </td>
              <td> 
                { item.ordenDetalle.unidad }
              </td>
              <td> 
                { libro.codigoIsbn }
              </td>
              <td> 
                { libro.titulo }
              </td>
              <td> 
                { CURRENCY_FORMAT.format(item.precio) }
              </td>
              <td> 
                { item.ordenDetalle.descuento + ' %' }
              </td>
              <td> 
                { CURRENCY_FORMAT.format( item.precio - (item.precio * ( item.ordenDetalle.descuento / 100 )) ) }
              </td>
              <td> 
                { CURRENCY_FORMAT.format( (item.precio - ( (item.precio * item.ordenDetalle.descuento) / 100 )) * (operationType === 'dev' ? item.cantidadDevuelta : item.cantidadLiquidar) ) }
              </td>
            </tr>
          })}
        </tbody>
      </Table>
    )
  }

  /**************************************** Data Table ****************************************/

  const [filterText, setFilterText] = useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const columns = [
    {
      name: <th>Número de Remisión</th>,
      selector: row => '#' + (row.idRemision).toString().padStart(4, '0'),
      sortable: true,
    },
    {
      name: <th>Proveedor</th>,
      selector: row => row.proveedor.razonSocial,
      sortable: true,
    },
    {
      name: <th>Cantidad a devolver</th>,
      selector: row => row.cantidadDevolver,
      sortable: true,
    },
    {
      name: <th>Monto de devolución</th>,
      selector: row => CURRENCY_FORMAT.format(row.montoDevolver),
      sortable: true,
    },
    {
      name: <th>Cantidad a liquidar</th>,
      selector: row => row.cantidadLiquidar,
      sortable: true,
    },
    {
      name: <th>Monto a liquidar</th>,
      selector: row => CURRENCY_FORMAT.format(row.montoLiquidar),
      sortable: true,
    },
    {
      name: <th>Vence</th>,
      selector: row => DATE_FORMAT.format(row.fechaVencimiento),
      sortable: true,
    },
    {
      name: <th>Estatus</th>,
      selector: row => <div style={{ textTransform: 'uppercase' }}>{ row.estatusDevolucion ? row.estatusDevolucion.replace(/_/g, " ") : '' }</div>,
      sortable: true,
    },
    {
      width: '200px',
      cell: row => 
      <>
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Resumen de Devolución</Tooltip>}>
          <Clipboard2CheckFill onClick={ () => settingInputs(row, false) } className="table-icon" />
        </OverlayTrigger>
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Liquidación Parcial</Tooltip>}>
          <CashStack onClick={ () => settingInputs(row, true) } className="table-icon" />
        </OverlayTrigger>
        { parseInt(rol) === 2 && 
          <>
            { row.estatusDevolucion === 'abierta' && row.entradas[0].devolucion &&
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Solicitar aprobación</Tooltip>}>
                <CartCheckFill onClick={ () => settingInputs(row, true, true) } className="table-icon" />
              </OverlayTrigger>
            }
          </>
        }
      </>,
    },
  ];

  useEffect(() => {
    if( cloneVencimientosList.length > 0) {
      let data = cloneVencimientosList

      if(filterText && filterText !== '' ) {
        data = cloneVencimientosList.filter(
          item => (item.idRemision && item.idRemision.toString().includes(filterText.toLowerCase())),
        )
      }

      //console.log("data filtered", data)
      setFilteredItems(data);
    }
  }, [ cloneVencimientosList, filterText ]);

  /**************************************** Data Table ****************************************/

  return (
    <>
      <Modal show={showPrint} onHide={ () => setShowPrint(false) } size="xl">
        <Modal.Header closeButton>
          <div className="title-form">{ 'Previo - Orden de Compra' }</div>
        </Modal.Header>
        <Modal.Body>
          <div align="right"><button type="button" onClick={ () => printPDF() } className="grl-btn">{ 'Descargar' }</button></div>
          <br/>
          <div id="App" className="app-container">
            <div id="infoApp" className="app">
              { remisionSelected != null && remisionSelected.idRemision != 0 &&
                <Container>
                  <Row>
                    <Col md={ 6 }>
                      <div> <img src={ laJornada } className="print-logo" /> </div>
                      <br/>
                      <div className="section-subtitle"> DEMOS DESARROLLO DE MEDIOS </div>
                      <div> AV CUAUHTÉMOC 1236 SANTA CRUZ </div>
                      <div> ATOYAC ALCALDÍA BENITO JUÁREZ </div>
                      <div> RFC: <b>DDM840626PM</b> </div>
                    </Col>
                    <Col md={ 6 }>
                      <div style={{ textAlign: 'right' }}>
                        <div className="title-form" style={{ textAlign: 'right', fontSize: '45px' }}> { (operationType === 'dev' ? 'DEVOLUCIÓN ' : 'LIQUIDACIÓN') + ' LIBRERÍA' } </div>
                        <br/>
                        <div> <span>Fecha:</span> <b>{ DATE_FORMAT_SHORT.format( remisionSelected.fechaAprobacion ? remisionSelected.fechaAprobacion : remisionSelected.entradas[0].fecha ) }</b> </div>
                        <div> <span>Folio:</span> <b>{ 'REM #' + remisionSelected.idRemision.toString().padStart(4, '0') + (idLiquidacionParcial > 0 ? ( " - LIQ #" + idLiquidacionParcial.toString().padStart(4, '0')) : '') }</b> </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-5">
                    <Col md={ 6 }>
                      <div className="print-title"> PROVEEDOR </div> <br/>
                      { remisionSelected.proveedor != null &&
                        <>
                          <div><b>PARA:</b></div>
                          <div className="section-subtitle"> { remisionSelected.proveedor.razonSocial } </div> <br/>
                          <div><b>DOMICILIO FISCAL:</b></div>
                          <div> { `${remisionSelected.proveedor.calle} ${remisionSelected.proveedor.numeroInt} ${remisionSelected.proveedor.numeroExt}, ${remisionSelected.proveedor.colonia}, ${getNombreEstado(remisionSelected.proveedor.idEstado).estado}` } </div>
                          <div> RFC: <b>{remisionSelected.proveedor.rfc}</b> </div> <br/>

                          <div> Fecha de Orden de Compra: <b>{remisionSelected ? DATE_FORMAT.format(remisionSelected.orden.fecha) : ''}</b> </div>
                          <div> Fecha de Remisión: <b>{remisionSelected ? DATE_FORMAT.format(remisionSelected.fecha) : ''}</b> </div>
                          <div> Descuento Proveedor: <b>{(remisionSelected ? remisionSelected.orden.descuentoProv : '') + ' %'}</b> </div>
                          <br/>
                          <div> Piezas a solicitadas: <b>{ remisionSelected.cantidadDevolver + remisionSelected.cantidadLiquidar }</b> </div>
                          { operationType === 'dev' ?
                            <div> Piezas a devolver: <b>{(remisionSelected ? remisionSelected.cantidadDevolver : '')}</b> </div>
                            : 
                            <div> Piezas a liquidar: <b>{
                              idLiquidacionParcial > 0 ? liquidacionesCantidad
                              : (remisionSelected ? remisionSelected.cantidadLiquidar : '')
                            }</b> </div> 
                          }
                        </>
                      }
                    </Col>
                    <Col md={ 6 }>
                      <div id="resume">
                        <div className="print-title"> RESUMEN </div> <br/>
                        <Col md={ 12 }>
                          <Table responsive>
                            <tbody>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> SUBTOTAL: </div>
                                </td>
                                <td> 
                                  { idLiquidacionParcial > 0 ? CURRENCY_FORMAT.format(liquidacionesSubtotal)
                                  : CURRENCY_FORMAT.format( operationType === 'dev' ? remisionSelected.cantidadRealDevolver : remisionSelected.cantidadRealLiquidar ) 
                                  }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> DESCUENTO: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format( operationType === 'dev' ? descuentoGlobal : descuentoGlobalLiq ) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> IVA: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format(remisionSelected.orden.impuestoRetenido) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> TOTAL: </div>
                                </td>
                                <td> 
                                  <b>{ idLiquidacionParcial > 0 ? CURRENCY_FORMAT.format(liquidacionesNeto)
                                  : (remisionSelected ? ( CURRENCY_FORMAT.format( operationType === 'dev' ? remisionSelected.montoDevolver : remisionSelected.montoLiquidar ) ) : '') 
                                  }</b>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          <br/>
                          <div className="desc-form">
                            { idLiquidacionParcial > 0 ? NumeroALetras(liquidacionesNeto)
                            : NumeroALetras( operationType === 'dev' ? remisionSelected.montoDevolver : remisionSelected.montoLiquidar ) 
                            } M.N.
                          </div>
                          <div className="desc-form"> <b>Moneda:</b> MXN </div>
                        </Col>
                        <Col md={ 12 }>
                          <div className="print-title"> Comentarios </div> <br/>
                          <div>{ remisionSelected.comentarios }</div>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-5">
                    <Col md={ 12 } >
                      <Container>
                        { partidasRes.length > 0 &&
                          getTableDevolucion(partidasRes[0]) 
                        }
                      </Container>
                    </Col>
                  </Row>
                </Container>
              }
            </div>
          </div>

          { partidasRes.length > 1 &&
            partidasRes.map((item, index) => {
              if( index !== 0 ) {
                return <>
                  <div id={ "App_" + index } className="app-container">
                    <div id={ "infoApp_" + index } className="app">
                      <Container>
                        <Row className="mt-5">
                          <Col md={ 12 } >
                            { getTableDevolucion(item) }
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </div>
                  <br/>
                </>
              }
            })
          }

        </Modal.Body>
      </Modal>

      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="returnForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div className="section-subtitle"> Generales </div>
              </Row>
              { remisionSelected && 
              <>
                <Row>
                  <Col md={12}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Proveedor </div>
                    <div>{ remisionSelected.proveedor.razonSocial }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Fecha de Orden de Compra </div>
                    <div>{ DATE_FORMAT.format(remisionSelected.orden.fecha) }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Fecha de Recepción </div>
                    <div>{ DATE_FORMAT.format(remisionSelected.fecha) }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Vencimiento </div>
                    <div>{ DATE_FORMAT.format(remisionSelected.fechaVencimiento) }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Descuento General </div>
                    <div>{ remisionSelected.orden.descuentoProv + ' %' }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Cantidad a devolver </div>
                    <div>{ (remisionSelected.cantidadDevolver)  }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Monto de devolución </div>
                    <div>{ (CURRENCY_FORMAT.format(remisionSelected.montoDevolver))  }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Cantidad a liquidar </div>
                    <div>{ (remisionSelected.cantidadLiquidar)  }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Monto de liquidar </div>
                    <div>{ (CURRENCY_FORMAT.format(remisionSelected.montoLiquidar))  }</div>
                  </Col>
                    { ( parseInt(rol) === 2 && (remisionSelected.estatusDevolucion === 'abierta' || remisionSelected.estatusDevolucion === 'rechazada') ) &&
                      <>
                        <Col md={12} style={{ paddingTop: 15 }}>
                          <div align="center">
                            <button type="submit" className="grl-btn">{ 'Guardar Devolución / Liquidación' }</button>
                          </div>
                        </Col>
                      </>
                    }
                </Row>
                <Row>
                  <div align="center">
                    { remisionSelected && remisionSelected.entradas[0].devolucion && 
                      <> 
                        <hr/>
                        <button type="button" className="cancel-btn" onClick={ () => viewPrint('dev') } >{ 'Visualizar Devolución' }</button>&nbsp;&nbsp;
                        <button type="button" className="cancel-btn" onClick={ () => viewPrint('liq') } >{ 'Visualizar Liquidación' }</button>
                      </>
                    }
                    { parseInt(rol) === 1 && remisionSelected && remisionSelected.entradas[0].devolucion && remisionSelected.estatusDevolucion === 'por_autorizar' &&
                      <>
                        <hr style={{ color: '#ae0107' }} />
                        <div style={{ marginTop: '15px' }}>
                          <button type="button" className="cancel-btn" onClick={ () => declineStatus(remisionSelected.idRemision) } >{ 'Rechazar Devolución' }</button>&nbsp;&nbsp;
                          <button type="button" className="grl-btn" onClick={ () => approvedStatus(remisionSelected.idRemision) } >{ 'Aprobar Devolución' }</button>
                        </div>
                      </>
                    }
                  </div>
                </Row>
              </>
              }
              <br/>
              <Row>
                <div className="section-subtitle"> Detalle de Devolución </div>
              </Row>
              { inputFields.map((item, index) => (
                <Row index={`devolucion_${index}`} className="align-items-center">  
                  <Col md={12}>
                    <div className="desc-form"> Titulo </div>
                    <div style={{ color: '#ae0107' }}>{ item.title }</div>
                  </Col> 
                  <Col md={6}>
                    <div className="desc-form"> Precio de Ingreso </div>
                    <div>{ CURRENCY_FORMAT.format(item.precio) }</div>
                  </Col>
                  <Col md={6}>
                    <div className="desc-form"> Descuento individual </div>
                    <div>{ (item.ordenDetalle.descuento ? item.ordenDetalle.descuento : 0) + " %" }</div>
                  </Col> 
                  <Col md={6}>
                    <div className="desc-form"> Catidad a devolver </div>
                    <div>{ item.cantidadDevuelta }</div>
                  </Col> 
                  <Col md={6}>
                    <div className="desc-form"> Monto de Catidad a devolver </div>
                    <div>{ CURRENCY_FORMAT.format( item.netoDevolucion ) }</div>
                  </Col> 
                  <Col md={6}>
                    <div className="desc-form"> Catidad a liquidar </div>
                    <div>{ (item.cantidadLiquidar) }</div>
                  </Col>
                  <Col md={6}>
                    <div className="desc-form"> Monto a liquidar </div>
                    <div>{ CURRENCY_FORMAT.format( item.netoLiquidacion ) }</div>
                  </Col>
                  <Col md={6}>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Cantidad a devolver">
                        <Form.Control required disabled={ disableEdit } type='number' min={ 0 } max={ item.cantidadDevueltaOrg } name={'cantidadDevuelta'} value={ item.cantidadDevuelta } onChange={event => handleFormChange(index, item, event)} placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Comentario">
                        <Form.Control required as="textarea" disabled={ disableEdit } name={'descripcion'} value={ item.descripcion } onChange={event => handleFormChange(index, item, event)} placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                </Row>
              ))}
            </Container>
            
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showParcial} onHide={ () => { setShowParcial(false); setIdLiquidacionParcial(0) } } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ 'Liquidación Parcial' }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <FloatingLabel label="Liquidaciones parciales previas">
              <Form.Select value={ idLiquidacionParcial } onChange={ (e) => onChangeLiquidacion( e.target.value ) }>
                <option value={ 0 } > Actual </option>
                { liquidacionesList.map( ( item, i ) => (
                  <option value={ item.idLiquidacionParcial }>{ DATE_FORMAT_COMPLETE.format(item.fecha) }</option>
                ) )}
              </Form.Select>
            </FloatingLabel>
            <br/>
          </div>
          <Form id="returnForm" onSubmit={ updateLiquidacion }>
            <Container>
              <Row>
                <div className="section-subtitle"> Generales </div>
              </Row>
              { remisionSelected && 
              <>
                <Row>
                  <Col md={12}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Proveedor </div>
                    <div>{ remisionSelected.proveedor.razonSocial }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Fecha de Orden de Compra </div>
                    <div>{ DATE_FORMAT.format(remisionSelected.orden.fecha) }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Fecha de Recepción </div>
                    <div>{ DATE_FORMAT.format(remisionSelected.fecha) }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Vencimiento </div>
                    <div>{ DATE_FORMAT.format(remisionSelected.fechaVencimiento) }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Descuento General </div>
                    <div>{ remisionSelected.orden.descuentoProv + ' %' }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Cantidad a liquidar </div>
                    <div>{ (liquidacionesCantidad)  }</div>
                  </Col>
                  <Col md={6} style={{ paddingTop: 15 }}>
                    <div className="desc-form" style={{ color: '#ae0107' }}> Monto de liquidar </div>
                    <div>{ (CURRENCY_FORMAT.format(liquidacionesNeto))  }</div>
                  </Col>
                </Row>
                <br/>
                <Row>
                  { remisionSelected && idLiquidacionParcial > 0 &&
                  <div align="center">
                    <br/>
                    <button type="button" className="cancel-btn" onClick={ () => viewPrint('liq') } >{ 'Visualizar Liquidación Parcial' }</button>
                    <hr/>
                  </div>
                  }
                  { ( parseInt(rol) === 2 && parseInt(idLiquidacionParcial) === 0 && liquidacionesCantidad > 0 && (remisionSelected.estatusDevolucion === 'abierta' || remisionSelected.estatusDevolucion === 'rechazada') ) &&
                    <>
                      <div style={{ paddingBottom: 15 }}>
                        <div align="center">
                          <button type="submit" className="grl-btn">{ 'Generar Liquidacion Parcial' }</button>
                          <hr/>
                        </div>
                      </div>
                    </>
                  }
                </Row>
              </>
              }
              <Row>
                <div className="section-subtitle"> Detalle de Liquidación Parcial </div>
              </Row>
              { inputLiquidaciones.map((item, index) => (
                <Row index={`devolucion_${index}`} className="align-items-center">  
                  <Col md={12}>
                    <div className="desc-form"> Titulo </div>
                    <div style={{ color: '#ae0107' }}>{ item.title }</div>
                  </Col> 
                  <Col md={6}>
                    <div className="desc-form"> Precio de Ingreso </div>
                    <div>{ CURRENCY_FORMAT.format(item.precio) }</div>
                  </Col>
                  <Col md={6}>
                    <div className="desc-form"> Descuento individual </div>
                    <div>{ (item.ordenDetalle.descuento ? item.ordenDetalle.descuento : 0) + " %" }</div>
                  </Col> 
                  <Col md={6}>
                    <div className="desc-form"> Catidad a liquidar </div>
                    <div>{ (item.cantidadLiquidar) }</div>
                  </Col>
                  <Col md={6}>
                    <div className="desc-form"> Monto a liquidar </div>
                    <div>{ CURRENCY_FORMAT.format( item.netoLiquidacion ) }</div>
                  </Col>
                </Row>
              ))}
            </Container>
            
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Tabs defaultActiveKey="proximos" className="mb-3" onSelect={(k) => setKey(k)}>
          <Tab eventKey="proximos" title={ <div className="section-subtitle"> Proximos Vencimientos </div> }>
          </Tab>
          <Tab eventKey="vencidos" title={ <div className="section-subtitle"> Vencidos </div> }>
          </Tab>
        </Tabs>

        <Container >
          <Row>
              <Col md={ 12 }>
                <Form.Group className='mb-3'>
                  <FloatingLabel label="Buscar por id de Remisión">
                    <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
                  </FloatingLabel>
                </Form.Group>
              </Col>
          </Row>
          <Row>
            { filteredItems.length > 0 && 
              <>
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  persistTableHead
                />
              </>
            }
            { filteredItems.length === 0 && 
              <div>Sin registros</div>
            }
          </Row>
        </Container>
      </Container>

    </>
  );
}

export default Devoluciones;
